import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../auth";

// Config is used to save temporary configurations for the website

const initialState = {
  sideNav: {
    expandPosts: false,
    expandRemoteConfig: false,
    expandAi: false,
    expandCatalog: false,
  },
};

const slice = createSlice({
  name: "config",
  initialState,
  reducers: {
    toggleSideNavPosts: (state) => {
      state.sideNav.expandPosts = !state.sideNav.expandPosts;
    },
    toggleSideNavRemoteConfig: (state) => {
      state.sideNav.expandRemoteConfig = !state.sideNav.expandRemoteConfig;
    },
    toggleSideNavAi: (state) => {
      state.sideNav.expandAi = !state.sideNav.expandAi;
    },
    toggleSideNavCatalog: (state) => {
      state.sideNav.expandCatalog = !state.sideNav.expandCatalog;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

export const {
  toggleSideNavPosts,
  toggleSideNavRemoteConfig,
  toggleSideNavAi,
  toggleSideNavCatalog,
} = slice.actions;

export default slice.reducer;
